<template>
  <div id="Home" v-if="homeInit">
    <!-- 首页 -->
    <div class="homeWrap" v-show="showSearch">
      <!-- 头部相关 -->
      <div class="header" ref="fixedHeader" :class="isFixed?'fixedHeader':''">
        <div class="i-logo" v-show="true">
          <!-- <img src="../assets/image/home/i-logo.png" alt /> -->
        </div>
        <div class="search-box">
          <div class="search-input">
            <input type="text" placeholder="输入关键词搜索游戏" @focus="onFocus()" />
            <van-icon name="search" class="i-search" color="#6A6B6E" />
          </div>
        </div>
        <div class="i-login" v-show="isWebView" @click="h5DownApp">
          <img src="../assets/image/home/appdown.png" alt />
        </div>
      </div>
      <!-- banner轮播图 -->
      <div class="banner-box">
        <swiper :options="swiperOption" class="swiper-container">
          <swiper-slide class="swiper-item" v-for="(item,index) in bannerList" :key="index">
            <img class="swiper-img" :src="item.path" />
          </swiper-slide>
        </swiper>
        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <!-- 今日主推 -->
      <div class="main-push-wrapper" v-show="zhutui.games[0].length!=0">
        <div
          class="main-push-content"
          @click="gameDateil('gamedetails',{gameid: zhutui.games[0].gid})"
        >
          <!-- 标题 -->
          <p class="c-title">
            <span>{{zhutui.title}}</span>
          </p>
          <!-- 主推游戏 -->
          <div class="c-game">
            <div class="i-game">
              <img :src="zhutui.games[0].icon_url" />
            </div>
            <div class="game-des">
              <div class="game-name-size">
                <span>{{zhutui.games[0].game_name}}</span>
              </div>
              <div class="game-type">
                <span
                  v-for="(item,index) in gameType(zhutui.games[0].game_type_name)"
                  :key="index"
                  v-show="index==0"
                >{{item}}</span>
                <span style="padding:0 .1rem">|</span>
                <span>{{zhutui.games[0].package_size}}</span>
              </div>
              <div class="game-title">
                <span>{{zhutui.games[0].short_info}}</span>
              </div>
              <div class="player-number">
                <span>{{zhutui.games[0].play_people}}人在玩</span>
              </div>
            </div>
            <div class="game-discount" v-if="isDiscount">
              <a>{{zhutui.games[0].discount}}折</a>
            </div>
            <div class="game-down" v-else>
              <a
                v-if="zhutui.games[0].pid!=100"
                @click.stop="downGame(zhutui.games[0].down_url,zhutui.games[0].pid,zhutui.games[0].gid)"
              >下载</a>
              <a
                v-else
                @click.stop="downGame(zhutui.games[0].down_url,zhutui.games[0].pid,zhutui.games[0].gid)"
              >开玩</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 快速导航栏和折扣区 -->
      <div class="discount-quickTab">
        <!-- 快速导航栏 -->
        <div class="quick-tab">
          <div class="quick-cont" v-for="(item,index) in isPlayer" :key="index">
            <router-link tag="div" :to="{name:item.link,query:{partId:item.id}}" class="quick-icon">
              <img :src="item.icon" alt />
            </router-link>
            <div class="title">{{item.title}}</div>
          </div>
        </div>
        <!-- 折扣专区 -->
        <div class="discount-wrapper" v-if="specials[1]!=undefined&&specials[1].games.length!=0">
          <div class="discount-cont">
            <div class="dis-title">
              <span class="title">{{specials[1].title}}</span>
              <span class="subTitle">{{specials[1].sub_title}}</span>
              <router-link
                tag="span"
                class="more"
                :to="{name:'hotGame',query:{partId:specials[1].id}}"
              >
                更多
                <i class="i-more"></i>
              </router-link>
            </div>
            <div class="dis-game" v-for="(item,index) in specials[1].games" :key="index">
              <div class="i-game" @click="gameDateil('gamedetails',{gameid: item.gid})">
                <img v-lazy="item.icon_url" />
              </div>
              <div class="game-des" @click="gameDateil('gamedetails',{gameid: item.gid})">
                <div class="game-name-size">
                  <p class="name">{{item.game_name}}</p>
                </div>
                <div class="type-size">
                  <span
                    v-for="(item,index) in gameType(item.game_type_name)"
                    :key="index"
                    v-show="index==0"
                  >{{item}}</span>
                  <span class="line">|</span>
                  <span>{{item.package_size}}</span>
                </div>
                <div class="game-title">
                  <span>{{item.short_info}}</span>
                </div>
                <div class="dis-num">
                  <span v-for="(_item,index) in gameType(item.game_label)" :key="index">{{_item}}</span>
                </div>
              </div>
              <div class="game-down">
                <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
                <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 热门推荐 -->
      <div class="hotGame-wrapper" v-if="specials[2]!=undefined&&specials[2].games.length!=0">
        <div class="hotGame-cont">
          <div class="dis-title">
            <span class="title">{{specials[2].title}}</span>
            <span class="subTitle">{{specials[2].sub_title}}</span>
            <router-link
              tag="span"
              class="more"
              :to="{name:'hotGame',query:{partId:specials[2].id}}"
            >
              更多
              <i class="i-more"></i>
            </router-link>
          </div>
          <div class="dis-game" v-for="(item,index) in specials[2].games" :key="index">
            <div class="i-game" @click="gameDateil('gamedetails',{gameid: item.gid})">
              <img v-lazy="item.icon_url" />
            </div>
            <div class="game-des" @click="gameDateil('gamedetails',{gameid: item.gid})">
              <div class="game-name-size">
                <p class="name">{{item.game_name}}</p>
              </div>
              <div class="type-size">
                <span
                  v-for="(item,index) in gameType(item.game_type_name)"
                  :key="index"
                  v-show="index==0"
                >{{item}}</span>
                <span class="line">|</span>
                <span>{{item.package_size}}</span>
              </div>
              <div class="game-title">
                <span>{{item.short_info}}</span>
              </div>
              <div class="dis-num">
                <span v-for="(_item,index) in gameType(item.game_label)" :key="index">{{_item}}</span>
              </div>
            </div>
            <div class="game-down">
              <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
              <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 新游推荐 -->
      <div class="newGame-wrapper" v-if="specials[3]!=undefined&&specials[3].games.length!=0">
        <div class="newGame-cont">
          <div class="dis-title">
            <span class="title">{{specials[3].title}}</span>
            <span class="subTitle">{{specials[3].sub_title}}</span>
            <router-link
              tag="span"
              class="more"
              :to="{name:'hotGame',query:{partId:specials[3].id}}"
            >
              更多
              <i class="i-more"></i>
            </router-link>
          </div>
          <div class="dis-game" v-for="(item,index) in specials[3].games" :key="index">
            <div class="i-game" @click="gameDateil('gamedetails',{gameid: item.gid})">
              <img v-lazy="item.icon_url" />
            </div>
            <div class="game-des" @click="gameDateil('gamedetails',{gameid: item.gid})">
              <div class="game-name-size">
                <p class="name">{{item.game_name}}</p>
              </div>
              <div class="type-size">
                <span
                  v-for="(item,index) in gameType(item.game_type_name)"
                  :key="index"
                  v-show="index==0"
                >{{item}}</span>
                <span class="line">|</span>
                <span>{{item.package_size}}</span>
              </div>
              <div class="game-title">
                <span>{{item.short_info}}</span>
              </div>
              <div class="dis-num">
                <span v-for="(_item,index) in gameType(item.game_label)" :key="index">{{_item}}</span>
              </div>
            </div>
            <div class="game-down">
              <a v-if="item.pid!=100" @click.stop="downGame(item.down_url,item.pid,item.gid)">下载</a>
              <a v-else @click.stop="downGame(item.down_url,item.pid,item.gid)">开玩</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 页脚 -->
      <Footer />
    </div>
    <!-- 搜索页 -->
    <transition name="searchPage">
      <SearchPage v-model="showSearch" />
    </transition>
    <!-- 收藏 -->
    <van-overlay :show="isShowCollect&&!isPC" z-index="101">
      <div class="collect-wrapper">
        <div class="downBar">
          <div class="banner-logo">
            <img src="@assets/image/app/banner-logo.png" alt />
          </div>
          <a class="down-logo" @click="h5DownApp">下载APP</a>
        </div>
        <div class="collectBox">
          <img src="@assets/image/app/collect-img.png" alt />
          <span class="close-collect" @click="closeCollect"></span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Footer from "../components/com/footer"; // 页脚
import SearchPage from "../components/content/home/searchPage"; // 搜索页
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import wapApiFun from "@/servers/wap-module/apiFun";
import { contTools, lyTool } from "../mixins/contMixins";
import { setDebounce } from "../assets/js/until";
import comTools from "@/assets/js/until";
export default {
  name: "home",
  mixins: [contTools, lyTool],
  components: {
    Footer,
    SearchPage,
    Swiper,
    SwiperSlide,
  },
  data() {
    let vm = this;
    return {
      homeInit: "",
      specials: "", // 各大专区
      isFixed: false, // 是否吸顶
      value: "",
      swiperOption: {
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          // type: "bullets",
          bulletActiveClass: "my-bullet-active",
          renderBullet: function (index, className) {
            return `<li class="${className}"></li>`;
          },
          clickable: true, //允许分页点击跳转
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          disableOnInteraction: false, // 触摸滑动后是否继续轮播
        },
        //开启循环模式
        loop: true,
        //开启鼠标滚轮控制Swiper切换
        mousewheel: true,
        effect: "fade",
        on: {
          click: function () {
            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
            // console.log(this); // -> Swiper
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
            const realIndex = this.realIndex;
            // console.log("realIndex", vm.bannerList);
            vm.jumpDetail(realIndex);
          },
        },
      },
      bannerList: [], // banner图
      zhutui: [], // 主推游戏
      moregame: [],
      active: 0,
      showSearch: true, // 是否显示搜索页
      quickTabList: [
        {
          icon: require("@assets/image/home/quick-tab/i-xinyou.png"),
          title: "新游",
          link: "hotGame",
          id: 5,
        },
        {
          icon: require("@assets/image/home/quick-tab/i-paihang.png"),
          title: "排行",
          link: "ranking",
          id: 0,
        },
        {
          icon: require("@assets/image/home/quick-tab/i-h5.png"),
          title: "H5",
          link: "h5Game",
          id: 0,
        },
        {
          icon: require("@assets/image/home/quick-tab/i-fenlei.png"),
          title: "分类",
          link: "classify",
          id: 0,
        },
      ], // quick-tab
      classifyList: [
        "二次元",
        "角色",
        "动作",
        "策略",
        "卡牌",
        "仙侠",
        "H5",
        "其他",
      ], // 分类列表
      classifyIndex: -1, // 分类索引
      isDiscount: true,
      isShowCollect: false, // 显示收藏
      appUrl: "", // app下载链接
    };
  },
  computed: {
    isPlayer() {
      let gId = this.$store.state.wapConfig.gid;
      if (gId == 1001 || gId == 1003) {
        // 折扣版
        // console.log("折扣版");
        let discount = {
          icon: require("@assets/image/home/quick-tab/i-zhekou.png"),
          title: "折扣",
          link: "hotGame",
          id: 3,
        };
        this.quickTabList.splice(1, 0, discount);
        this.isDiscount = true;
        return this.quickTabList;
      } else {
        // 玩家版
        // console.log("玩家版");
        let hot = {
          icon: require("@assets/image/home/quick-tab/i-hot.png"),
          title: "热门",
          link: "hotGame",
          id: 4,
        };
        this.quickTabList.splice(1, 0, hot);
        this.isDiscount = false;
        return this.quickTabList;
      }
    },
    isWebView() {
      let ua = navigator.userAgent;
      if (ua.indexOf("LiuyiH5WebView") > -1) {
        return false;
      } else {
        return true;
      }
    },
  },

  directives: {
    // 注意
    swiper: directive,
  },
  watch: {},
  created() {
    this.initData();
    this._isShowCollect();
    this.initView();
    // location.replace(location.href.replace(location.search, ""));
    // this.$bus.on("showHome", flag => {
    //   this.isSearch = flag;
    //   console.log(this.isSearch);
    // });
    // console.log('home',this.$store.state.apiData);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // 初始化数据
    initData() {
      let data = this.wapConfig();
      data.sign = comTools.querySort(data);
      wapApiFun.home(data).then((res) => {
        if (res.code == 200) {
          this.homeInit = res.data;
          this.appUrl = res.data.app_url;
          this.$store.commit("setApkAppUrl", res.data.app_url);
          this.bannerList = this.homeInit.banners;
          this.zhutui = this.homeInit.web_games[0];
          this.specials = this.homeInit.web_games; // 各大专区
          // console.log("66", this.zhutui);
        }
      });
    },
    // 下载app
    h5DownApp() {
      if (this.appUrl) {
        window.open(this.appUrl);
      } else {
        this.$toast("敬请期待!");
      }
    },
    /**
     * 轮播跳转
     * type 详情页:1 活动页:2
     */
    jumpDetail(index) {
      let _type = this.bannerList[index].type;
      if (_type == 1) {
        this.$router.push({
          name: "gameDetails",
          query: { gameid: this.bannerList[index].content_id },
        });
      } else if (_type == 2) {
        this.$router.push({
          name: "activityDetails",
          query: { id: this.bannerList[index].content_id },
        });
      }
    },
    // 轮播图点击
    swipeClick(index) {
      console.log(index);
      if (index === 0) {
        window.open(
          "http://h5.gamehl.com/h5Sdk/v1/view/index.html?glPid=100&glGid=100274&glPMid=1"
        );
      }
    },
    // 分类列表点击事件
    onClassifyTab(index) {
      this.classifyIndex = index;
      this.$toast("暂未开放此功能!");
      this.$router.push({
        path: "/categorygame",
        query: {
          categoryId: index,
        },
      });
    },
    // 输入框聚焦事件
    onFocus() {
      // console.log("输入框聚焦事件");
      this.showSearch = false;
    },
    // 吸顶事件
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let headerH = this.$refs.fixedHeader
        ? this.$refs.fixedHeader.offsetHeight
        : 0;
      if (scrollTop > headerH) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    // 关闭收藏
    closeCollect() {
      this.isShowCollect = false;
      this.$cookies.set("isCollectId", "1", 60 * 60 * 24);
    },
    _isShowCollect() {
      let ua = navigator.userAgent;
      if (
        ua.indexOf("LiuyiH5WebView") > -1 ||
        this.$cookies.get("isCollectId") != null
      ) {
        this.isShowCollect = false;
      } else {
        this.isShowCollect = true;
      }
    },
  },
  beforeDestroy() {
    // console.log("HOME销毁");
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
@import "../assets/css/com.less";
@themeC: #ff971c;
#Home {
  width: 100%;
  position: relative;
  // background-color: skyblue;
  background-color: #fff;
  .homeWrap {
    width: 100%;
    height: 100%;

    // 头部相关
    .header {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      .jc-around();
      min-height: 1.6rem /* 120/75 */;
      z-index: 100;
      .i-logo {
        width: 2rem /* 150/75 */;
        height: 0.733333rem /* 55/75 */;
        background: url("../assets/image/home/i-logo.png") no-repeat center;
        background-size: contain;
      }
      .search-box {
        width: 70%;
        // margin-right: 0.333333rem /* 25/75 */;
        // border: 1px solid #000;
        background: transparent;
        .search-input {
          position: relative;
          padding: 0.266667rem /* 20/75 */ 0;
          input {
            width: 100%;
            // border: 1px solid #ddd;
            border-radius: 0.933333rem /* 70/75 */;
            padding: 0.2rem /* 15/75 */ 0;
            padding-left: 15px;
            box-sizing: border-box;
            display: inline-block;
            line-height: 20px;
            background: rgba(250, 250, 250, 0.9);
          }
          .i-search {
            position: absolute;
            right: 0.4rem /* 30/75 */;
            top: 50%;
            transform: translate(0, -50%);
          }
          ::-webkit-input-placeholder {
            /* Chrome/Opera/Safari */
            color: #888;
            font-size: 13px;
          }
        }
      }
      &.fixedHeader {
        position: fixed;
        transition: all 1s;
        z-index: 100;
        background-color: #fff;
        input {
          background: rgba(241, 241, 241, 1);
        }
      }
      .i-login {
        width: 0.6rem /* 60/75 */;
        img {
          .img();
        }
        // height: .9rem /* 55/75 */;
        // background: url("../assets/image/home/appdown.png") no-repeat center;
        // background-size: contain;
      }
    }
    // banner轮播图
    .banner-box {
      width: 100%;
      margin: 0 auto;
      position: relative;
      .swiper-img {
        width: 100%;
      }
      .swiper-pagination {
        position: absolute;
        left: 0;
        bottom: 4rem;
        width: 100%;
        .jc-content();
        padding: 0.2rem 0;
        /deep/.swiper-pagination-bullet {
          margin: 0 0.1rem;
          width: 0.2rem;
          height: 0.2rem;
          background-color: #e0e0e0;
          opacity: 1;
          transition: all 0.2s;
        }
        /deep/.my-bullet-active {
          width: 0.6rem;
          height: 0.2rem;
          border-radius: 0.1rem;
          background: #ffaa2f;
          opacity: 1;
          margin: 0 0.2rem;
          transition: all 0.3s;
        }
      }

      // .van-swipe {
      //   width: 100%;
      //   .van-swipe-item {
      //     width: 100%;
      //     img {
      //       width: 100%;
      //     }
      //   }
      // }
    }
    // 今日主推
    .main-push-wrapper {
      position: absolute;
      left: 0;
      top: 7.3rem;
      width: 100%;
      // background-color: #fff;
      z-index: 98;
      .main-push-content {
        width: 92%;
        background-color: #fff;
        margin: 0 auto;
        box-shadow: 0px 4px 0.2rem 1px #f1f1f1;
        overflow: hidden;
        position: relative;
        .borderRadius();
        .c-title {
          display: flex;
          justify-self: start;
          span {
            // position: absolute;
            // left: 0;
            // top: 0;
            display: inline-block;
            // height: 100%;
            font-size: 0.4rem;
            color: #fff;
            background-color: @themeC;
            padding: 0 0.2rem;
          }
        }
        .c-game {
          width: 100%;
          display: flex;
          margin-top: 0.1rem;
          margin-bottom: 0.2rem;
          .i-game {
            width: 20%;
            margin: 0 0.3rem;
            img {
              .img();
            }
          }
          .game-des {
            flex-direction: column;
            align-content: center;
            display: flex;
            .game-name-size {
              span {
                font-size: 0.5rem;
                padding-right: 0.3rem;
                display: inline-block;
                // &:nth-of-type(1) {
                //   font-size: 0.5rem;
                //   padding-right: 0.3rem;
                // }
                // &:nth-of-type(2) {
                //   .font-color();
                //   font-size: 0.35rem;
                // }
              }
            }
            .game-type {
              color: #999;
              // padding-bottom: 0.1rem;
              span {
                font-size: 0.3rem;
                &:nth-of-type(2) {
                  padding: 0 0.1rem;
                }
              }
            }
            .game-title {
              width: 100%;

              color: #999;
              font-size: 0.3rem;
              // padding-bottom: 0.1rem;
              span {
                display: inline-block;
                width: 80%;
                .ellipsis();
              }
            }
            .player-number {
              color: #ffa641;
              font-size: 0.35rem;
            }
          }
        }
        // .game-discount {
        //   background-color: @themeC;
        //   color: #fff;
        //   border-radius: 0.2rem;
        //   padding: 0.1rem 0.4rem;
        // }
        .game-down,
        .game-discount {
          position: absolute;
          right: 0.3rem;
          top: 50%;
          transform: translate(0, -50%);
          .theme-bg-color();
          border-radius: 0.2rem;
          padding: 0.1rem 0.4rem;
          a {
            color: #fff;
          }
        }
      }
    }
    // 快速导航栏和折扣区
    .discount-quickTab {
      width: 92%;
      height: 100%;
      margin: 0 auto;
      .borderRadius();
      .boxShadow(1px);
      background-color: #fff;
      overflow: hidden;
      margin-top: 0.4rem;
      // 快速导航栏
      .quick-tab {
        width: 100%;
        margin: 0 auto;
        padding: 0.5rem 0;
        .jc-around();
        .quick-cont {
          .quick-icon {
            width: 1rem;
            img {
              .img();
            }
          }
          .title {
            margin-top: 0.1rem;
            text-align: center;
            font-size: 0.4rem;
            color: #333;
          }
        }
      }
      // 折扣专区
      .discount-wrapper {
        // width: 100%;
        .discount-cont {
          position: relative;
          padding-bottom: 0.2rem;
          .dis-title {
            padding: 0.4rem 0;
            padding-top: 0;
            position: relative;
            .title {
              padding-left: 0.5rem;
              padding-right: 0.2rem;
            }
            .subTitle {
              font-size: 0.3rem;
              color: #666;
            }
            .more {
              color: #666;
              position: absolute;
              right: 0.5rem;
              bottom: 50%;
              transform: translate(0, 50%);
              font-size: 0.4rem;
              .i-more {
                display: inline-block;
                width: 0.3rem;
                height: 0.3rem;
                background: url("~@assets/image/home/i-more.png") no-repeat;
                background-size: contain;
              }
            }
            // font-size: .5rem;
          }
          .dis-game {
            width: 100%;
            position: relative;
            margin-bottom: 0.5rem;
            .jc-content(flex-start);
            .i-game {
              width: 1.8rem;
              margin: 0 0.3rem;
              img {
                .img();
              }
            }
            .game-des {
              min-width: 50%;
              flex-direction: column;
              display: flex;
              // margin-right: 1rem;
              .game-name-size {
                width: 100%;
                .name {
                  font-size: 0.45rem;
                  // font-weight: bold;
                  padding-right: 0.3rem;
                }
              }
              .type-size {
                width: 100%;
                .font-color();
                font-size: 0.25rem;
                .line {
                  padding: 0 3px;
                }
              }
              // .game-type {
              //   color: #999;
              //   margin-bottom: 0.1rem;
              //   span {
              //     padding-right: 0.2rem;
              //     font-size: 0.4rem;
              //   }
              // }
              .game-title {
                width: 100%;

                color: #999;
                font-size: 0.3rem;
                // padding-bottom: 0.1rem;
                span {
                  display: inline-block;
                  width: 80%;
                  .ellipsis();
                }
              }
              .dis-num {
                display: flex;
                span {
                  font-size: 0.25rem;
                  border-radius: 1px;
                  // display: inline-block;
                  padding: 1px 0.2rem;
                  margin-right: 0.2rem;
                  &:nth-of-type(1) {
                    color: #d4704e;
                    background-color: #feedde;
                  }
                  &:nth-of-type(2) {
                    color: #666;
                    background-color: #f5f5f5;
                  }
                  &:nth-of-type(3) {
                    color: #d4704e;
                    background-color: #feedde;
                  }
                }
              }
            }
            .game-down {
              position: absolute;
              right: 0.3rem;
              top: 50%;
              transform: translate(0, -50%);
              background-color: @themeC;
              border-radius: 0.2rem;
              padding: 0.1rem 0.4rem;
              a {
                color: #fff;
              }
            }
          }
        }
      }
    }
    // 新游推荐&& 热游推荐
    .hotGame-wrapper,
    .newGame-wrapper {
      width: 100%;
      .hotGame-cont,
      .newGame-cont {
        .borderRadius();
        .boxShadow(1px);
        width: 92%;
        background-color: #fff;
        position: relative;
        padding-bottom: 0.2rem;
        margin: 0 auto;
        margin-top: 0.6rem;
        .dis-title {
          padding: 0.4rem 0;
          position: relative;
          .title {
            padding-left: 0.5rem;
            padding-right: 0.2rem;
          }
          .subTitle {
            font-size: 0.3rem;
            color: #666;
          }
          .more {
            color: #666;
            position: absolute;
            right: 0.5rem;
            bottom: 50%;
            transform: translate(0, 50%);
            font-size: 0.4rem;
            .i-more {
              display: inline-block;
              width: 0.3rem;
              height: 0.3rem;
              background: url("~@assets/image/home/i-more.png") no-repeat;
              background-size: contain;
            }
          }
          // font-size: .5rem;
        }
        .dis-game {
          width: 100%;
          position: relative;
          margin-bottom: 0.5rem;
          .jc-content(flex-start);
          .i-game {
            width: 18%;
            margin: 0 0.3rem;
            img {
              .img();
            }
          }
          .game-des {
            min-width: 50%;
            flex-direction: column;
            display: flex;
            // margin-right: 1rem;
            .game-name-size {
              .name {
                font-size: 0.5rem;
                padding-right: 0.3rem;
              }
            }
            .type-size {
              .font-color();
              font-size: 0.25rem;
              .line {
                padding: 0 3px;
              }
            }
            // .game-type {
            //   color: #999;
            //   margin-bottom: 0.1rem;
            //   span {
            //     padding-right: 0.2rem;
            //     font-size: 0.4rem;
            //   }
            // }
            .game-title {
              width: 100%;

              color: #999;
              font-size: 0.3rem;
              // padding-bottom: 0.1rem;
              span {
                display: inline-block;
                width: 80%;
                .ellipsis();
              }
            }
            .dis-num {
              display: flex;
              span {
                font-size: 0.25rem;
                // border-radius: 0.2rem;
                // display: inline-block;
                padding: 1px 0.2rem;
                margin-right: 0.2rem;
                &:nth-of-type(1) {
                  color: #d4704e;
                  background-color: #feedde;
                }
                &:nth-of-type(2) {
                  color: #666;
                  background-color: #f5f5f5;
                }
                &:nth-of-type(3) {
                  color: #d4704e;
                  background-color: #feedde;
                }
              }
            }
          }
          .game-down {
            position: absolute;
            right: 0.3rem;
            top: 50%;
            transform: translate(0, -50%);
            background-color: @themeC;
            border-radius: 0.2rem;
            padding: 0.1rem 0.4rem;
            a {
              color: #fff;
            }
          }
        }
      }
    }
  }

  // 动画
  // .home-enter-active,
  // .home-leave-active {
  //   transition: opacity .1s;
  // }
  // .home-enter,
  // .home-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  //   opacity: 0;
  // }

  // .searchPage-enter-active,
  // .searchPage-leave-active {
  //   transition: opacity .1s;
  // }
  // .searchPage-enter,
  // .searchPage-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  //   opacity: 0;
  // }
}
</style>
